<template>
  <div class="help is-danger" v-if="errors.length > 0">
    <ul>
      <li v-for="e in errors" :key=e>
        {{ e }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FormErrors',
  props: {
    errors: {
      type: Array,
      required: true,
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormErrors.vue?11bcf588